// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface StudentLessonWritingByActivityRepresentation
 */
export interface StudentLessonWritingByActivityRepresentation {
  /**
   *
   * @type {Array<string>}
   * @memberof StudentLessonWritingByActivityRepresentation
   */
  activityIds: Array<string>
  /**
   *
   * @type {Array<Array<string>>}
   * @memberof StudentLessonWritingByActivityRepresentation
   */
  studentAnswers: Array<Array<string>>
}

/**
 * Check if a given object implements the StudentLessonWritingByActivityRepresentation interface.
 */
export function instanceOfStudentLessonWritingByActivityRepresentation(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'activityIds' in value
  isInstance = isInstance && 'studentAnswers' in value

  return isInstance
}

export function StudentLessonWritingByActivityRepresentationFromJSON(
  json: any,
): StudentLessonWritingByActivityRepresentation {
  return StudentLessonWritingByActivityRepresentationFromJSONTyped(json, false)
}

export function StudentLessonWritingByActivityRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentLessonWritingByActivityRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activityIds: json['activity_ids'],
    studentAnswers: json['student_answers'],
  }
}

export function StudentLessonWritingByActivityRepresentationToJSON(
  value?: StudentLessonWritingByActivityRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activity_ids: value.activityIds,
    student_answers: value.studentAnswers,
  }
}
